import { render, staticRenderFns } from "./attendance-gallery.vue?vue&type=template&id=71fd511a&scoped=true&"
import script from "./attendance-gallery.vue?vue&type=script&lang=js&"
export * from "./attendance-gallery.vue?vue&type=script&lang=js&"
import style0 from "./attendance-gallery.vue?vue&type=style&index=0&id=71fd511a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd511a",
  null
  
)

export default component.exports